<main class="main">
  <nav class="sidebarLeft sidebar">
    <div class="sidebar-sticky">
      <div class="proj-sidebar-info">
        <span *ngIf="!isNSI"  class="icon-left text-secondary"></span>
        <a *ngIf="!isNSI" [routerLink]="[destinoRouter]">   {{'WorkflowCreate.Back' | translate}}</a>
        <div class="mt-3">
          <label for="workflowCode">
            {{ workflowDefinition.workflowCodeCGA }}
          </label>
          <h1 class="text-secondary">
            {{ workflowDefinition.title }}
          </h1>
          <p class="text-secondary">
          </p>
          <a [routerLink]="" aria-label="Link com Instruções" (click)="getInstructions()" class="card-link" referrerpolicy="origin">{{'WorkflowSearch.Instructions' | translate}}</a>
        </div>
      </div>

      <div class="proj-sidebar-navegation" *ngIf="currentStep != 97 && !isReadonly && !serviceManifestRejectSucessfully && !isAtendimento">
        <button *ngIf="isOnPreStage() && currentStep==1" aria-label="Salvar" type="button" class="btn btn-primary" id="wf-save-button" (click)="savePreStageInstance()" [disabled]="subscriberSearched"
                name="wf-save-button">
          <span class="icon-save"></span><span>{{'Workflow.Save' | translate}}</span>
        </button>
        <button *ngIf="isOnPreStage() && currentStep==1" aria-label="Terminar" type="button" class="btn btn-outline-primary mt-3" (click)="onDeleteWorkflow($event)" id="wf-terminate-button" [disabled]="subscriberSearched"
                name="wf-terminate-button" visualActionUnauthorized>
          <span class="icon-close"></span><span>{{'Workflow.Terminate' | translate}}</span>
        </button>
        <br />
      </div>

    </div>
  </nav>
  <div class="wrapper">
    <div class="container-fluid">
      <alert></alert>

      <!-- Subscritor -->
      <div *ngIf="currentStep==0" class="row">
        <div class="col-sm-12">
          <h2 *ngIf=" workflowCode !== 'PEDI008B' " class="text-primary mb-4">{{'WorkflowCreate.SubscriberSearch' | translate}}</h2>
          <h2 *ngIf=" workflowCode === 'PEDI008B' " class="text-primary mb-4">{{'WorkflowCreate.ExSubscriberSearch' | translate}}</h2>
        </div>
        <div class="col-sm-4">
          <form name="cgaSubscriberSearch" #cgaSubscriberSearch="ngForm">
            <div class="form-group">
              <label for="subscriberNumber">{{'WorkflowCreate.SubscriberNumber' | translate}}</label>
              <input type="text" numeric="7" class="form-control" id="subscriberNumber" name="subscriberNumber" [disabled]="isAtendimento" placeholder="000000" maxlength="7" [(ngModel)]="subscriberNumber" required>
            </div>
          </form>
        </div>
      </div>
        <!-- É ex Subscritor -->
        <!--div-- *ngIf="currentStep==0 && workflowCode=== 'PEDI008B' " class="row">
          <div class="col-sm-12">
            <h2 class="text-primary mb-4">{{'WorkflowCreate.ExSubscriberSearch' | translate}}</h2>
          </div>
          <div class="col-sm-4">
            <form name="exCgaSubscriberSearch" #exCgaSubscriberSearch="ngForm">
              <div class="form-group">
                <label for="exSubscriberNumber">{{'WorkflowCreate.ExSubscriberNumber' | translate}}</label>
                <input type="text" numeric="7" class="form-control" id="exSubscriberNumber" name="exSubscriberNumber" [disabled]="isAtendimento" placeholder="000000" maxlength="7" [(ngModel)]="exSubscriberNumber" required>
              </div>
            </form>
          </div>
        </!--div-->
        <!-- End Subscritor -->
        <!-- Fundamento do pedido -->
        <!-- APOSENTAÇÃO-->
        <div *ngIf="currentStep==1 && workflowCode.indexOf('PEDI001') > -1" class="row requestType">
          <div class="col-sm-12">
            <h2 class="text-primary mb-4">{{'WorkflowCreate.RequestType' | translate}}</h2>
          </div>

          <div class="col-sm-12">
            <h3>{{'WorkflowCreate.VoluntaryRequest' | translate}}</h3>

            <div class="form-check mb-4" *ngFor="let rowVol of childWorkFlowsVoluntaria">
              <div>
                <input class="form-check-input"
                       aria-controls="collapseManual"
                       type="radio"
                       name="Fundamento do Pedido"
                       id="{{rowVol.title}}"
                       value="{{rowVol.title}}"
                       (change)="onSelectionChange(rowVol)">
                <label class="form-check-label align-items-center form-check-label-weight" for="{{rowVol.title}}">
                  {{rowVol.title}}
                  <span class="text-gray-600 ft-sz-12 ml-1 mr-2">({{'WorkflowCreate.SubscriberType' | translate}}: {{rowVol.workflowTargetAudience}})</span>
                  <a (click)="rowVol.isCollapsed = !rowVol.isCollapsed"
                     [routerLink]=""
                     [attr.aria-expanded]="!rowVol.isCollapsed"
                     aria-controls="collapseBasic"
                     class="text-primary text-decoration-none"
                     [ngClass]="(rowVol.isCollapsed)?'icon-minus':'icon-more'">
                  </a>
                </label>
                <div id="collapseManual" #collapse="bs-collapse" [collapse]="!rowVol.isCollapsed">
                  <div class="pt-2 text-gray-600 mt-2 mb-5"><span [innerHTML]="rowVol.description"></span></div>
                </div>
              </div>
            </div>
          </div>


          <div class="col-sm-12">
            <h3>{{'WorkflowCreate.MandatoryRequest' | translate}}</h3>

            <div class="form-check mb-4" *ngFor="let rowObrig of childWorkFlowsObrigatoria">

              <div>
                <input class="form-check-input"
                       aria-controls="collapseManual"
                       type="radio"
                       name="Fundamento do Pedido"
                       id="{{rowObrig.title}}"
                       value="{{rowObrig.title}}"
                       (change)="onSelectionChange(rowObrig)">
                <label class="form-check-label align-items-center form-check-label-weight" for="{{rowObrig.title}}">
                  {{rowObrig.title}}
                  <span class="text-gray-600 ft-sz-12 ml-1 mr-2">({{'WorkflowCreate.SubscriberType' | translate}}: {{rowObrig.workflowTargetAudience}})</span>
                  <a (click)="rowObrig.isCollapsed = !rowObrig.isCollapsed"
                     [routerLink]=""
                     [attr.aria-expanded]="!rowObrig.isCollapsed"
                     aria-controls="collapseBasic"
                     class="text-primary text-decoration-none"
                     [ngClass]="(rowObrig.isCollapsed)?'icon-minus':'icon-more'">
                  </a>
                </label>
                <div id="collapseManual" #collapse="bs-collapse" [collapse]="!rowObrig.isCollapsed">
                  <div class="pt-2 text-gray-600 mt-2 mb-5"><span [innerHTML]="rowObrig.description"></span></div>
                </div>

              </div>

            </div>


        </div>
      </div>
      <!-- SERVIÇO APOSENTAÇÃO EX SUBSCRITOR MANIFESTO-->
      <div *ngIf="currentStep==98 && !isAllowPersonalData" class="row requestType">
        <div class="container-fluid">
          <alert></alert>
          <div *ngIf="isFromCGA" style="margin-bottom:15px">
            <h2 class="text-primary mb-0">Documentação submetida pelo ex-subscritor</h2>
            <br />
            <div class="col-sm-12">
              <prestage-documentation [workflowCode]="workflowCode" [subscriberNumber]="subscriberNumber" [isReadonly]="true" [workflowInstanceId]="workflowInstanceId"
                                      (documentsListChanged)="onDocumentsListChanged($event)" [documentsList]="documentsList"></prestage-documentation>
            </div>
          </div>
          <h2 class="text-primary mb-0">{{'SubmissionServiceLandingPage.ConfirmSubmissionTitle' | translate}}</h2>
          <br>
          {{'SubmissionServiceLandingPage.ConfirmSubmissionText' | translate}}{{preStageForm.exSubscritorIdentificacao.nome}} - {{subscriberNumber}}{{'SubmissionServiceLandingPage.ConfirmSubmissionText2' | translate}}
          <br>
          <b>{{'SubmissionServiceLandingPage.ConfirmSubmissionText3' | translate}}</b>

        </div>
      </div>
      <!-- SERVIÇO APOSENTAÇÃO EX SUBSCRITOR MANIFESTO -->
      <div *ngIf="currentStep==98 && isAllowPersonalData" class="row requestType">
        <div class="container-fluid">
          <alert></alert>
          <div *ngIf="isFromCGA" style="margin-bottom:15px">
            <h2 class="text-primary mb-0">Documentação submetida pelo ex-subscritor</h2>
            <br />
            <div class="col-sm-12">
              <prestage-documentation [workflowCode]="workflowCode" [subscriberNumber]="subscriberNumber" [isReadonly]="true" [workflowInstanceId]="workflowInstanceId"
                                      (documentsListChanged)="onDocumentsListChanged($event)" [documentsList]="documentsList"></prestage-documentation>
            </div>
          </div>

          <div>
            <h2 class="mt-4">
              Identificação do Subscritor
            </h2>

            <div class="col-sm-9">
              <div class="form-group">
                <label class="disabled" for="nome">
                  Nome
                </label>
                <input class="form-control" type="text" [(ngModel)]="preStageForm.exSubscritorIdentificacao.nome" name="nome" #nome="ngModel" readonly>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <label class="disabled" for="IdentificationNumber">{{'CardSubscriberIdentification.IdentificationNumber' | translate}}</label>
                <div class="form-row">
                  <div class="col-sm-8">
                    <input class="form-control" type="text" [(ngModel)]="preStageForm.exSubscritorIdentificacao.numeroIdentificacao" name="numeroIdentificacao" #identificationNumber="ngModel" maxlength="8" disabled>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <label class="disabled" for="telemovel">Telemóvel</label>
                <input class="form-control" type="text" [(ngModel)]="preStageForm.exSubscritorIdentificacao.telemovel" name="telemovel" #telemovel="ngModel" maxlength="9" disabled>
              </div>
            </div>

            <div class="col-sm-8">
              <div class="form-group">
                <label class="disabled" for="email">E-mail</label>
                <input class="form-control" type="text" [(ngModel)]="preStageForm.exSubscritorIdentificacao.email" name="email" #email="ngModel" disabled>
              </div>
            </div>
            &nbsp;
          </div>

          <div style="margin-top:-20px" *ngIf="workflowCode.indexOf('PEDI005') > -1">
            <h2 class="mt-4">
              Motivo de aposentação
            </h2>

            <div class="col-sm-9">
              <div class="row">
                <div class="col-sm-12" style="margin-bottom:15px">
                  <textarea disabled class="form-control" name="subscriberMotiveDescServ" [(ngModel)]="preStageForm.preStageInfo.subscriberMotiveDescServ" > </textarea>
                </div>
              </div>
            </div>
            &nbsp;
          </div>

          <h2 class="text-primary mb-0">{{'SubmissionServiceLandingPage.ConfirmSubmissionTitle' | translate}}</h2>
          <br>
          {{'SubmissionServiceLandingPage.ConfirmSubmissionText4' | translate}}
          <br>
          <b>{{'SubmissionServiceLandingPage.ConfirmSubmissionText3' | translate}}</b>

        </div>
      </div>
      <!-- SERVIÇO APOSENTAÇÃO EX SUBSCRITOR MANIFESTO REJEICAO-->
      <div *ngIf="currentStep==97" class="row requestType">
        <div class="container-fluid" *ngIf="!serviceManifestRejectSucessfully">
          <alert></alert>
          <h2 class="text-primary mb-0">{{'ServiceManifestRejectionPage.ServiceManifestRejectionTitle' | translate}}</h2>
          <br>
          <div class="col-sm-12">
            <label for="motivo">
              <span style="color:red">* </span>{{'ServiceManifestRejectionPage.ServiceManifestRejectionMotiveLabel' | translate}}
            </label>
            <textarea class="form-control" name="motivoRejeicaoManifestoEx" [(ngModel)]="motivoRejeicaoManifestoEx" required rows="10" cols="100" maxlength="3000"> </textarea>
          </div>
        </div>
      </div>
      <!-- CONTAGEM TEMPO -->
      <div *ngIf="currentStep==1 && workflowCode.indexOf('PEDI0020') > -1" class="row requestType">
        <div class="col-sm-12">
          <h3 style="padding-bottom:24px">{{'WorkflowCreate.TimeCount.Title' | translate}}</h3>
          <div class="form-check mb-4" *ngFor="let rowObrig of fakeChildWorkFlows">

              <div>
                <input class="form-check-input"
                       aria-controls="collapseManual"
                       type="radio"
                       name="Fundamento do Pedido"
                       id="{{rowObrig.title}}"
                       [disabled]="rowObrig.isLogActive=='N'"
                       value="{{rowObrig.title}}"
                       (change)="onSelectionChange(rowObrig)">
                <label class="form-check-label align-items-center form-check-label-weight" for="{{rowObrig.title}}">
                  {{rowObrig.title}}<span *ngIf="rowObrig.subTitle !=null">{{"  " + rowObrig.subTitle}}</span>


                </label>


              </div>

            </div>
          </div>


        </div>
        <!-- APOSENTAÇÃO/CONTAGEM TEMPO EX SUBSCRITOR PRESTAGE -->
        <div *ngIf="currentStep==1 && (workflowCode.indexOf('PEDI008') > -1 || workflowCode.indexOf('PEDI005') > -1)" class="row requestType">
          <main [ngSwitch]="preStageStep" class="col-sm-12">
            <!--PRESTAGE STEP 1-->
            <ng-container *ngSwitchCase="1">
              <label for="Campos obrigatórios" *ngIf="!isReadonly" style="color:#DB3347"><span class="mandatory"></span>{{'Workflow.Mandatory' | translate}}</label>

            <div>
              <h2 class="mt-4">
                Identificação do Subscritor
              </h2>
              <!--IDENTIFICAÇÃO SUBSCRITOR-->
              <div class="row">
                <div class="col-sm-9">
                  <div class="form-group">
                    <label class="disabled" for="nome">
                      Nome
                    </label>
                    <input class="form-control" type="text"
                           [(ngModel)]="preStageForm.exSubscritorIdentificacao.nome" name="nome" #nome="ngModel" required readonly>
                    <validation-message [control]="nome"></validation-message>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label class="disabled" for="dataNascimento">
                      Data de Nascimento
                    </label>
                    <input bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
                           [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD',containerClass: 'theme-default', showWeekNumbers:false }"
                           [(ngModel)]="preStageForm.exSubscritorIdentificacao.dataNascimento" name="dataNascimento" #dataNascimento="bsDatepicker" disabled
                           maxlength="10"
                           (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)">
                    <validation-message [control]="dataNascimento"></validation-message>
                  </div>
                </div>


                  <div class="col-sm-5">
                    <div class="form-group">
                      <label class="disabled" for="DocumentType">{{'CardSubscriberIdentification.DocumentType' | translate}}</label>
                      <input class="form-control" type="text" [(ngModel)]="documentTypeDescription" name="documentTypeCode" #documentTypeCode="ngModel" disabled>

                      <validation-message [control]="documentTypeCode"></validation-message>
                    </div>
                  </div>

                  <div class="col-sm-4">
                    <div class="form-group">
                      <label class="disabled" for="IdentificationNumber">{{'CardSubscriberIdentification.IdentificationNumber' | translate}}</label>
                      <div class="form-row">
                        <div class="col-sm-8">
                          <input class="form-control" type="text" [(ngModel)]="preStageForm.exSubscritorIdentificacao.numeroIdentificacao" name="numeroIdentificacao" #identificationNumber="ngModel" maxlength="8" disabled>
                          <validation-message [control]="numeroIdentificacao"></validation-message>
                        </div>
                        <div class="col-sm-4">
                          <input class="form-control" type="text" name="numeroIdentificacaoLast4" disabled>
                          <validation-message [control]="numeroIdentificacaoLast4"></validation-message>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-3">
                    <div class="form-group">
                      <label class="disabled" for="FiscalNumber">{{'CardSubscriberIdentification.FiscalNumber' | translate}}</label>
                      <input class="form-control" type="text" numeric="9" [(ngModel)]="preStageForm.exSubscritorIdentificacao.nif" name="nif" #fiscalNumber="ngModel" maxlength="9" disabled>
                      <validation-message [control]="nif"></validation-message>
                    </div>
                  </div>

                  <div class="col-sm-4">
                    <div class="form-group">
                      <label class="disabled" for="telemovel">Telemóvel</label>
                      <input class="form-control" type="text" [(ngModel)]="preStageForm.exSubscritorIdentificacao.telemovel" name="telemovel" #telemovel="ngModel" maxlength="9" disabled>
                      <validation-message [control]="telemovel"></validation-message>
                    </div>
                  </div>

                  <div class="col-sm-8">
                    <div class="form-group">
                      <label class="disabled" for="email">E-mail</label>
                      <input class="form-control" type="text" [(ngModel)]="preStageForm.exSubscritorIdentificacao.email" name="email" #email="ngModel" disabled>
                      <validation-message [control]="email"></validation-message>
                    </div>
                  </div>

                  <div class="col-sm-12 form-group text-secondary ft-sz-12" style="margin-top:15px">
                    <label style="color:#012169">
                      {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.InformacaoSubscritor' | translate}}
                    </label>

                    <label style="color:#012169">
                      O e-mail e o telemóvel são pré-preenchidos com a informação registada na CGA Directa. Caso não estejam atualizados, altere-os na CGA Directa, no menu Ficha utilizador.
                    </label>
                  </div>

                </div>
              </div>
              <div class="row">
                <label class="col-sm-12 form-group" style="margin-top:15px;">

                  <span>
                    <span *ngIf="!isReadonly" class="mandatory">*</span>
                    Autoriza o envio dos seus contatos (e-mail e telemóvel) para o serviço indicado como responsável pelo preenchimento do pedido, de forma a facilitar futuras comunicações? Caso não autorize, o seu pedido poderá tornar-se mais moroso, devido à eventual necessidade do serviço o contactar.
                  </span>
                </label>
                <div class="col-sm-12 form-group">
                  <div class="form-check mb-4">
                    <div>
                      <input class="form-check-input perguntaConcorda1" style="margin-top:0.25rem !important"
                             aria-controls="collapseManual"
                             type="radio"
                             [disabled]="isReadonly"
                             id="allowPersonalDataYes"
                             [checked]="preStageForm.preStageInfo.allowPersonalData == 'S'"
                             value="true"
                             (change)="onAutorizaChange($event)">
                      <label class="form-check-label align-items-center" for="allowPersonalDataYes">
                        {{'WorkflowCreate.ContagemTempoExSubs.YES' | translate}}
                      </label>
                    </div>
                  </div>
                  <div class="form-check mb-4">
                    <div>
                      <input class="form-check-input perguntaConcorda1" style="margin-top:0.25rem !important"
                             aria-controls="collapseManual"
                             type="radio"
                             [disabled]="isReadonly"
                             id="allowPersonalDataNo"
                             [checked]="preStageForm.preStageInfo.allowPersonalData == 'N'"
                             value="false"
                             (change)="onAutorizaChange($event)">
                      <label class="form-check-label align-items-center" for="allowPersonalDataNo">
                        {{'WorkflowCreate.ContagemTempoExSubs.NO' | translate}}
                      </label>
                    </div>
                  </div>

                </div>
              </div>
              <div style="margin-top:-20px" *ngIf="workflowCode.indexOf('PEDI005') > -1">
                <h2 class="mt-4">
                  Motivo de aposentação
                </h2>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="isReadonly?'disabled':''">
                        <span *ngIf="!isReadonly" class="mandatory">*</span>
                        Motivo
                      </label>
                      <select class="custom-select" [(ngModel)]="subscriberMotive"
                              name="motivoCode" #motivoCode="ngModel"
                              required (ngModelChange)="prestageMotiveChanged()" [disabled]="isReadonly"
                              nullableSelect>
                        <default-dropdown-values></default-dropdown-values>
                        <option *ngFor="let motivo of dropdownListaMotivosEXAP" [value]="motivo.value">
                          {{motivo.description}}
                        </option>
                      </select>
                      <validation-message [control]="motivoCode"></validation-message>
                    </div>
                  </div>

                </div>
                <div class="row">
                  <div class="col-sm-12" style="margin-bottom:15px">
                    <textarea disabled class="form-control" name="subscriberMotiveDescServ" [(ngModel)]="preStageForm.preStageInfo.subscriberMotiveDescServ" required> </textarea>
                  </div>
                </div>
              </div>

              <div>
                <h2 class="mt-4">
                  {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Titulo' | translate}}
                </h2>
                <!--SERVIÇO SUGERIDO-->
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="disabled" for="designacao">
                        {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Designacao' | translate}}
                        <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.ContagemTempoExSubs.Designacao' | translate}}" container="body" placement="bottom"></span>
                      </label>
                      <input class="form-control" type="text"
                             [(ngModel)]="preStageForm.exSubscritorServicoSugerido.designacao" name="designacao" #designacao="ngModel" required readonly>
                      <validation-message [control]="designacao"></validation-message>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label class="disabled" for="localidade">
                        {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Localidade' | translate}}
                      </label>
                      <input class="form-control" type="text"
                             [(ngModel)]="preStageForm.exSubscritorServicoSugerido.localidade" name="localidade" #localidade="ngModel" required readonly>
                      <validation-message [control]="localidade"></validation-message>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label class="disabled" for="distrito">
                        {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Distrito' | translate}}
                      </label>
                      <input class="form-control" type="text"
                             [(ngModel)]="preStageForm.exSubscritorServicoSugerido.distrito" name="distrito" #distrito="ngModel" required readonly>
                      <validation-message [control]="distrito"></validation-message>
                    </div>
                  </div>


                  <!-- LABELS INFORMATIVAS CENARIOS SERVIÇO SUGERIDO PRESTAGE -->
                  <div style="margin-top:-10px">
                    <!-- SEM LABEL INFORMATIVA - CENARIO 4,5 -->
                    <!--SERVICO ATIVO E CERTIFICADO - SUBCASO CENARIO 1 AF-->
                    <label class="col-sm-12 form-group text-secondary ft-sz-12" style="color:#012169;" *ngIf="(currentServiceScenario == Scenarios.Ativo || currentServiceScenario == Scenarios.AtivoIntegradoExtinto || currentServiceScenario == Scenarios.AtivoIntegradoAtivo) && (preStageForm.exSubscritorServicoSugerido.origemPreenchimento=='CT' || preStageForm.exSubscritorServicoSugerido.origemPreenchimento=='DAR')">
                      {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.ServicoCertificado'  | translate}}
                    </label>
                    <!--SERVICO INATIVO E NAO INTEGRADO - ESCOLHA CGA - CENARIO 2 AF-->
                    <label class="col-sm-12 form-group text-secondary ft-sz-12" style="color:#012169;" *ngIf="currentServiceScenario == Scenarios.InativoNaoIntegrado && subscriberServices?.length > 0">
                      {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.ServicoExtinto'  | translate}}
                    </label>
                    <!--SERVICO INATIVO E INTEGRADO - CENARIO 3 AF-->
                    <label class="col-sm-12 form-group text-secondary ft-sz-12" style="color:#012169;" *ngIf="currentServiceScenario == Scenarios.InativoIntegrado && subscriberServices?.length>0">
                      {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.ServicoInactivo'  | translate}}
                    </label>
                    <!--SERVICO INATIVO E INTEGRADO/NAO INTEGRADO - SEM VINCULOS - CENARIO 2 e 3 AF-->
                    <label class="col-sm-12 form-group text-secondary ft-sz-12" style="color:#012169;" *ngIf="(currentServiceScenario == Scenarios.InativoNaoIntegrado || currentServiceScenario == Scenarios.InativoIntegrado) && subscriberServices?.length == 0">
                      {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.ServicoMorto'  | translate}}
                    </label>
                    <!--SERVICO MORTO - CENARIO 6 AF-->
                    <label class="col-sm-12 form-group text-secondary ft-sz-12" style="color:#012169;" *ngIf="currentServiceScenario == Scenarios.NaoInscritoOuSemSubsAtivos && subscriberServices?.length>0">
                      {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.ServicoInvalido'  | translate}}
                    </label>
                    <!--SERVICO MORTO - SEM VINCULOS - CENARIO 6 AF-->
                    <label class="col-sm-12 form-group text-secondary ft-sz-12" style="color:#012169;" *ngIf="currentServiceScenario == Scenarios.NaoInscritoOuSemSubsAtivos && (subscriberServices?.length==0 || subscriberServices == undefined)">
                      {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.ServicoInvalidoSemVinculos'  | translate}}
                    </label>
                  </div>
                </div>
              </div>



              <!--ESCOLHA CONCORDA?-->
              <div *ngIf="currentServiceScenario == Scenarios.Ativo || currentServiceScenario == Scenarios.AtivoIntegradoExtinto || currentServiceScenario == Scenarios.AtivoIntegradoAtivo">
                <h2 class="mt-4">
                  {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.Concorda' | translate}}
                </h2>
                <div class="row col-sm-12 form-group" style="margin-top:22px">
                  <div class="form-check mb-4">
                    <div>
                      <input class="form-check-input perguntaConcorda1" style="margin-top:0.25rem !important"
                             aria-controls="collapseManual"
                             type="radio"
                             [disabled]="isReadonly"
                             id="{{'WorkflowCreate.ContagemTempoExSubs.YES' | translate}}"
                             [checked]="respostaExSubscritor && respostaExSubscritor != null"
                             value="true"
                             (change)="onConcordaChange($event)">
                      <label class="form-check-label align-items-center" for="{{'WorkflowCreate.ContagemTempoExSubs.YES' | translate}}">
                        {{'WorkflowCreate.ContagemTempoExSubs.YES' | translate}}
                      </label>
                    </div>
                  </div>
                  <div class="form-check mb-4">
                    <div>
                      <input class="form-check-input perguntaConcorda1" style="margin-top:0.25rem !important"
                             aria-controls="collapseManual"
                             type="radio"
                             [disabled]="isReadonly"
                             id="{{'WorkflowCreate.ContagemTempoExSubs.NO' | translate}}"
                             [checked]="!respostaExSubscritor && respostaExSubscritor != null"
                             value="false"
                             (change)="onConcordaChange($event)">
                      <label class="form-check-label align-items-center" for="{{'WorkflowCreate.ContagemTempoExSubs.NO' | translate}}">
                        {{'WorkflowCreate.ContagemTempoExSubs.NO' | translate}}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <!--NÃO CONCORDA -> OUTROS VINCULOS - TABELA-->
              <ng-container *ngIf="subscriberServices?.length>0">
                <div>
                  <h2 class="mt-4">
                    {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.EscolhaServico' | translate}}
                  </h2>
                  <div class="row">
                    <div class="col-sm-12 form-group">
                      <vinculos-list [subscriberServices]="subscriberServices"
                                     [suggestedService]="preStageForm.exSubscritorServicoSugerido"
                                     [chaveServicoEscolhido]="preStageForm.preStageInfo.serviceFinal"
                                     [finalService]="finalService"
                                     [externalReseter]="choosenVinculoReset"
                                     [isEnabled]="respostaExSubscritor == false && !isReadonly"
                                     (onOptionClicked)="onSelectionVinculoChange($event)">
                      </vinculos-list>
                    </div>
                  </div>
                </div>
              </ng-container>

            </ng-container>

            <!--PRESTAGE STEP 2-->
            <ng-container *ngSwitchCase="2">
              <ng-container *ngIf="preStageForm.preStageInfo.isSentCGA == 'false' || cgaSubmitedDocuments;else pedidoCGA">
                <div class="content-send text-center row">
                  <div class="icons text-primary col-sm-12 " style="text-align:center">
                    <span class="icon-loading"></span>
                  </div>
                  <div class="mb-4  col-sm-12 ">
                    <h5 *ngIf="!cgaSubmitedDocuments" class="text-gray-700">{{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.Confirmacao' | translate : {servico:getDesignacaoServicoEscolhido(preStageForm.preStageInfo.serviceFinal)} }}</h5>
                    <h5 *ngIf="cgaSubmitedDocuments" class="text-gray-700">{{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.EscolhaServicoCGA' | translate }}</h5>

                  </div>
                </div>
              </ng-container>
              <ng-template #pedidoCGA>
                <form name="cgaWorkflowForm" #cgaWorkflowForm="ngForm">


                  <fieldset class="row form-group">
                    <div class="col-sm-12">
                      <label for="Campos obrigatórios" style="color:#DB3347"><span class="mandatory"></span>{{'Workflow.Mandatory' | translate}}</label>
                    </div>
                    <h2 class="col-sm-12 mt-4">
                      {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.ValidacaoServico' | translate}}
                    </h2>
                    <div class="col-sm-12 " style="margin-top: 18px">
                      <span>{{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.EnvioCGA.Explicacao' | translate}}</span>
                    </div>
                  </fieldset>
                  <!--DOCUMENTACAO PARA CGA-->
                  <div class="row">


                    <div class="form-group" style="margin-top:-4px">
                      <h2 class="col-sm-12 mt-4">
                        {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.EnvioCGA.TitleDocumentacao' | translate}}
                      </h2>

                    </div>
                    <div class="col-sm-12" style="margin-top:-15px">
                      <documentation-help class="col-sm-12"></documentation-help>
                      <prestage-documentation class="col-sm-12" [workflowCode]="workflowCode" [subscriberNumber]="subscriberNumber" [isReadonly]="isReadonly" [workflowInstanceId]="workflowInstanceId"
                                              (documentsListChanged)="onDocumentsListChanged($event)" [documentsList]="documentsList"></prestage-documentation>
                    </div>


                    <!--DOCUMENTACAO PARA CGA TABELA-->
                    <div class="col-sm-12" *ngIf="cgaJustificationFileExist=='ERROR'">
                      <input class="form-control" type="text" style="opacity:0;"
                             [(ngModel)]="cgaJustificationFileExist" #cgaJustificationFileExistInput="ngModel" name="cgaJustificationFileExistInput" required maxlength="3000" />
                      <span *ngIf="cgaJustificationFileExist=='ERROR'"
                            [innerText]="'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.TabelaFicheiros.Obrigatorio' | translate"
                            style="font-size: 80%; color: #DB3347;">
                      </span>
                    </div>
                    <!-- OBSERVACOES-->
                    <div class="form-group">
                      <h2 class="col-sm-12 mt-4">
                        {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.EnvioCGA.Title' | translate}}
                      </h2>
                    </div>

                    <div class="col-sm-12 form-group">
                      <textarea class="form-control" type="text" [placeholder]="'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.EnvioCGA.MotivoPlaceholder' | translate" [disabled]="isReadonly"
                                [(ngModel)]="cgaJustification" #cgaJustificationInput="ngModel" name="cgaJustificationInput" rows="10" cols="100" maxlength="1000"></textarea>


                    </div>
                  </div>
                </form>
              </ng-template>
            </ng-container>

          </main>


        </div>

      <!-- End Fundamento do pedido -->
      <!-- Manifestação de interesse -->
      <div *ngIf="currentStep==2" class="row">
        <div class="col-sm-12">
          <h2 class="text-primary mb-4">{{'WorkflowCreate.ManifestTitle' | translate}}</h2>
          <p>
            {{'WorkflowCreate.ManifestRequest' | translate}}
          </p>
          <b> {{'WorkflowCreate.ManifestConfirmation' | translate}}</b>
        </div>
      </div>



      <div *ngIf="currentStep==96" class="row">
        <div style="margin-top:-20px">
          <h2 class="mt-4">
            Motivo da anulação
          </h2>
          <div class="row">
            <div class="col-sm-9">
              <div class="form-group">
                <label class="isReadonly?'disabled':''">
                  <span class="mandatory">*</span>
                  Motivo
                </label>
                <select class="custom-select" [(ngModel)]="annulationMotive"
                        name="annulationCode" #annulationCode="ngModel"
                        required (ngModelChange)="annulationMotiveChanged()"
                        nullableSelect>
                  <default-dropdown-values></default-dropdown-values>
                  <option *ngFor="let annulation of dropdownListaMotivosAnnulation" [value]="annulation.value">
                    {{annulation.description}}
                  </option>
                </select>
                <validation-message [control]="annulationCode"></validation-message>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="bAnnulationExtraDesc">
            <div class="col-sm-12" >
              <label for="motivo">
                <span style="color:red">* </span>{{'Workflow.AnnulationMotiveLabel' | translate}}
              </label>
              <textarea class="form-control" name="annulacaoMotiveDesc" #annulacaoMotiveDesc="ngModel"
                        [(ngModel)]="annulationMotiveOtherDesc" required rows="10" 
                        maxlength="3000"> </textarea>
              <validation-message [control]="annulacaoMotiveDesc"></validation-message>
            </div>
          </div>
        </div>
      </div>

      <!-- End Manifestação de interesse -->
      <!-- FOOTER BUTTONS -->
      <div *ngIf="currentStep!=2 && currentStep != 98  && currentStep != 97 && currentStep != -1 && currentStep != 96">
        <!-- caso -1 para pagina em branco para loader-->
        <div class="row mt-4 mb-50">
          <div class="col-sm-6">
            <div class="btn-group" role="group" aria-label="Retroceder no pedido" *ngIf="currentStep != 0 && preStageStep != 1 && currentStep != 99">
              <button appDebounceClick (debounceClick)="onStepBefore()" aria-label="Retroceder no pedido" type="button" class="btn btn-outline-primary" id="wf-before-button" name="wf-before-button">
                <span class="icon-left"></span> <span>{{'WorkflowCreate.Before' | translate}}</span>
              </button>
            </div>
          </div>
          <div class="col-sm-6 text-end">
            <div class="btn-group" role="group" aria-label="Avançar no pedido">
              <button appDebounceClick type="button" [disabled]="CheckIfPreStageSeguinteIsDisabled()" class="btn btn-primary" aria-label="Avançar no pedido" id="wf-next-button" name="wf-next-button" (debounceClick)="onStepNext()" *ngIf="currentStep!=2" [ngClass]="{'qw-12': this.childWorkflow }">
                <span *ngIf="(preStageForm?.preStageInfo?.isSentCGA == 'false' || cgaSubmitedDocuments) && preStageStep == 2" class="icon-send"></span>
                <span>{{ (((preStageForm?.preStageInfo?.isSentCGA == 'false' || cgaSubmitedDocuments) && preStageStep == 2)? 'WorkflowCreate.Send' : 'WorkflowCreate.Next') | translate}}</span>
                <span *ngIf="!((preStageForm?.preStageInfo?.isSentCGA == 'false' || cgaSubmitedDocuments) && preStageStep == 2)" class="icon-right"></span>
              </button>
            </div>
          </div>
        </div>
      </div>

        <div *ngIf="currentStep==2">
          <div class="row mt-4 mb-50">
            <div class="col-sm-6">
              <div class="btn-group" role="group" aria-label="Cancelar">
                <button appDebounceClick type="button" aria-label="Cancelar" class="btn btn-outline-primary" id="wf-cancel-button" name="wf-cancel-button" (debounceClick)="onCancel()">
                  <span class="icon-close"></span> <span>{{'WorkflowCreate.Cancel' | translate}}</span>
                </button>
              </div>
            </div>
            <div class="col-sm-6 text-end">
              <div class="btn-group" role="group" aria-label="Enviar informação">
                <button #wfSendButton appDebounceClick type="button" aria-label="Enviar informação" class="btn btn-primary" id="wf-send-button" name="wf-send-button" (debounceClick)="createManifest($event, wfSendButton)">
                  <span class="icon-send"></span>
                  <span>{{'WorkflowCreate.Send' | translate}}</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- FOOTER EX SUBSCRITOR MANIFESTO REJEICAO -->
        <div *ngIf="currentStep==97 && !serviceManifestRejectSucessfully">
          <div class="row mt-4 mb-50">
            <div class="col-sm-6">
              <div class="btn-group" role="group" aria-label="Anterior">
                <button appDebounceClick type="button" aria-label="Anterior" class="btn btn-outline-primary" id="wf-cancel-button" name="wf-cancel-button" (debounceClick)="rejectionServiceManifestBackButton()">
                  <span class="icon-left"></span> <span>{{'ServiceManifestRejectionPage.PreviousButton' | translate}}</span>
                </button>
              </div>
            </div>
            <div class="col-sm-6 text-end">
              <div class="btn-group" role="group" aria-label="Enviar informação">
                <button #wfSendButton appDebounceClick type="button" aria-label="Enviar informação" [disabled]="(motivoRejeicaoManifestoEx == null || motivoRejeicaoManifestoEx=='undefined') && !serviceManifestRejectSucessfully" class="btn btn-primary" id="wf-send-button" name="wf-send-button" (debounceClick)="rejectServiceManifest()" [debounceTime]="700">
                  <span class="icon-send"></span>
                  <span>{{'ServiceManifestRejectionPage.SendButton' | translate}}</span>

                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- FOOTER EX SUBSCRITOR MANIFESTO -->
        <div *ngIf="currentStep==98">
          <div class="row mt-4 mb-50">
            <div class="col-sm-6">
              <div class="btn-group" role="group" aria-label="Cancelar">
                <button appDebounceClick type="button" *ngIf="!isFromCGA" aria-label="Cancelar" class="btn btn-outline-primary" id="wf-cancel-button" name="wf-cancel-button" (debounceClick)="currentStep = 97;">
                  <span class="icon-close"></span> <span>{{'SubmissionServiceLandingPage.RejectButton' | translate}}</span>
                </button>
              </div>
            </div>
            <div class="col-sm-6 text-end">
              <div class="btn-group" role="group" aria-label="Enviar informação">
                <button #wfSendButton appDebounceClick type="button" aria-label="Enviar informação" class="btn btn-primary" id="wf-send-button" name="wf-send-button" (debounceClick)="acceptServiceManifest()">
                  <span>{{'SubmissionServiceLandingPage.AcceptButton' | translate}}</span>
                  <span class="icon-right"></span>
                </button>
              </div>
            </div>
          </div>
        </div>

      <!-- FOOTER EX SUBSCRITOR ANULAÇÃO -->
      <div *ngIf="currentStep==96">
        <div class="row mt-4 mb-50">
          <div class="col-sm-6">
            <div class="btn-group" role="group" aria-label="Cancelar">
              <button appDebounceClick type="button" aria-label="Cancelar" class="btn btn-outline-primary" id="wf-cancel-button" name="wf-cancel-button" (debounceClick)="onExit()">
                <span class="icon-close"></span> <span>{{'Workflow.Cancel' | translate}}</span>
              </button>
            </div>
          </div>
          <div class="col-sm-6 text-end">
            <div class="btn-group" role="group" aria-label="Anular">
              <button #wfSendButton appDebounceClick type="button" aria-label="Anular" class="btn btn-primary" id="wf-del-button" name="wf-del-button" (debounceClick)="onAnnulationWorkflow()">
                <span>{{'Workflow.Terminate' | translate}}</span>
                <span class="icon-right"></span>
              </button>
            </div>
          </div>
        </div>
      </div>


      </div>

    </div>
  <aside>
    <subscriber-info *ngIf="( workflowInstanceId>0 && currentStep==1 && !isExSubscritor) || (workflowInstanceId>0 && currentStep==99 && isExSubscritor)" [subscriberNumber]="subscriberNumber" [workflowCode]="workflowCode" [displaySubscriberInfo]="true" [instanceId]="workflowInstanceId"></subscriber-info>
  </aside>
</main>


<ng-template #withData>
  <form name="cgaWorkflowForm" #cgaWorkflowForm="ngForm">
    <div class="modal-header">
      <h5 class="modal-title text-warning d-flex align-items-center">
        <span class="icon-warning mr-2 ft-sz-24"></span>
        {{'WorkflowCreate.WithDraftTitle' | translate}}
      </h5>
      <button type="button" class="close pull-right" aria-label="Fechar" (click)="modalRef.hide()">
        <span aria-hidden="true" class="icon-close"></span>
      </button>
    </div>
    <div class="modal-body">
      {{('WorkflowCreate.WithDraftText' | translate:{'tipoPedido':tipoPedidoDescricao}) + ' ' + subscriberNumber +'.'}}

      <br><br>
      {{'WorkflowCreate.WithDraftText2' | translate}}
      <div class="form-check mt-3">
        <input class="form-check-input" type="radio" name="withDraftOp" id="withDraftOp1" value="withDraftOp1" [(ngModel)]="optDraft" checked required>
        <label class="form-check-label" for="withDraftOp1">
          {{'WorkflowCreate.WithDraftOp1' | translate}}
        </label>
      </div>

      <div class="form-check mt-3" *ngIf="allowDelete">
        <input class="form-check-input" type="radio" name="withDraftOp" id="withDraftOp2" value="withDraftOp2" [(ngModel)]="optDraft" required>
        <label class="form-check-label" for="withDraftOp2">
          {{'WorkflowCreate.WithDraftOp2' | translate}}
        </label>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-primary" aria-label="Rejeitar" (click)="decline()"><span class="icon-close"></span><span>{{'WorkflowCreate.Cancel' | translate}}</span></button>
      <button type="button" class="btn btn-primary" aria-label="Confirmar" (click)="confirmNew()" [disabled]="cgaWorkflowForm.invalid"><span class="icon-check"></span><span>{{'WorkflowCreate.Confirm' | translate}}</span></button>
    </div>
  </form>
</ng-template>
<ng-template #noRegistration>
  <div class="modal-header">
    <h5 class="modal-title text-danger d-flex align-items-center">
      <span class="icon-error mr-2 ft-sz-24"></span>
      {{'WorkflowCreate.NoRegistrationTitle' | translate}}
    </h5>
    <button type="button" class="close pull-right" aria-label="Fechar" (click)="modalRef.hide()">
      <span aria-hidden="true" class="icon-close"></span>
    </button>
  </div>
  <div class="modal-body">
    {{( workflowCode.indexOf("PEDI0020") === -1 ? 'WorkflowCreate.NoRegistrationText' : 'WorkflowCreate.NoRegistrationTextCT') | translate}}
    <br><br>
    {{'WorkflowCreate.NoRegistrationText2' | translate}}
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" aria-label="Rejeitar" (click)="decline()"><span class="icon-check"></span><span>Ok</span></button>
  </div>
</ng-template>
<ng-template #revisionNeeded>
  <div class="modal-header">
    <h5 class="modal-title text-warning d-flex align-items-center">
      <span class="icon-warning mr-2 ft-sz-24"></span>
      {{'WorkflowCreate.RevisionNeededTitle' | translate}}
    </h5>
    <button type="button" class="close pull-right" aria-label="Fechar" (click)="modalRef.hide()">
      <span aria-hidden="true" class="icon-close"></span>
    </button>
  </div>
  <div class="modal-body">
    {{'WorkflowCreate.RevisionNeededText1' | translate}}
    <br>
    {{'WorkflowCreate.RevisionNeededText2' | translate}}
    <i>{{'WorkflowCreate.RevisionNeededText3' | translate}}</i>
    {{'WorkflowCreate.RevisionNeededText4' | translate}}
    <br><br>
    <b>{{'WorkflowCreate.RevisionNeededText5' | translate}}</b>
  </div>
  <div class="modal-footer">
    <!--<button type="button" class="btn btn-primary" aria-label="Rejeitar" (click)="modalRef.hide()"><span class="icon-check"></span><span>Ok</span></button>-->
    <button type="button" class="btn btn-outline-primary" aria-label="Rejeitar" (click)="decline()"><span class="icon-close"></span><span>{{'WorkflowCreate.Cancel' | translate}}</span></button>
    <button type="button" class="btn btn-primary" aria-label="Confirmar" (click)="confirmRevision()"><span class="icon-check"></span><span>Ok</span></button>
  </div>
</ng-template>


<!--<pre>{{workflowInstance.formData | json}}</pre>-->
<!-- FORM FAKE -->
<form id="formGetFile" #cgaGetFileForm="ngForm" name="formGetFile" method="POST" target="_blank" referrerpolicy="origin">
  <input #cgaGetFileFormInput type="hidden" name="h_queryParams" id="h_queryParams" value="">
  <input type="hidden" name="h_transfDir" id="h_transfDir" value="Download">
  <input type="hidden" name="h_operId" id="h_operId" value="PubFich">
</form>
